import { booleanToString, formatDate } from '@brandbank/portal-components';
import { Card, CardContent, CardHeader, Stack } from '@mui/material';
import { CardRow } from 'features/ui';
import useUser from 'hooks/useUser';
import { useFeedDetailsCtx } from '../FeedDetails.context';
import DownloadFeedCoverageButtons from './DownloadFeedCoverageButtons';

const FeedsOverviewCoverageInfo = () => {
  const { hasRole } = useUser();
  const { detail } = useFeedDetailsCtx();

  return (
    <Card>
      <CardHeader
        title='Coverage Information'
        titleTypographyProps={{
          variant: 'h6',
        }}
      />

      <CardContent>
        <Stack spacing={1}>
          <CardRow
            label='Coverage Status:'
            value={detail.coverageImportStatus}
          />
          <CardRow
            label='Allowed to import coverage?:'
            value={booleanToString(detail.coverageImport)}
          />
          <CardRow
            label='Coverage used to filter products?:'
            value={booleanToString(detail.usesRangeList)}
          />
          <CardRow
            label='API Coverage Imported (UTC):'
            value={detail.gtinsImported ? formatDate(detail.gtinsImported, true, true) : null}
          />
          <CardRow
            label='API Coverage Cached (UTC):'
            value={detail.xmlCoverageCached ? formatDate(detail.xmlCoverageCached, true, true) : null}
          />
        </Stack>

        {hasRole('Download Feed Coverage') && !!detail.coverageImportStatus ? (
          <DownloadFeedCoverageButtons subcode={detail.subscriberCode ?? ''} />
        ) : (
          <></>
        )}
      </CardContent>
    </Card>
  );
};

export default FeedsOverviewCoverageInfo;
